/**
 * dir-w | backOffice
 * Application main routing
 *
 * Last update : January 24, 2024 | @rizkiprasetya
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Configuration } from './config/configuration';
import { PageLoadingComponent } from './shared/page-loading/page-loading.component';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';

const appRoutes: Routes = [
  {
    path: 'administrations',
    loadChildren: () =>
      import('./modules/administrations/administrations.module').then(
        (m) => m.AdministrationsModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'developer',
    loadChildren: () =>
      import('./modules/developer/developer.module').then(
        (m) => m.DeveloperModule
      ),
  },
  {
    path: 'email',
    loadChildren: () =>
      import('./modules/email/email.module').then((m) => m.EmailModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./modules/forgot-password/forgot-password.module').then(
        (m) => m.ForgotPasswordModule
      ),
  },
  {
    path: 'loading',
    title: `${
      Configuration.appDeveloper + ' | ' + Configuration.appTitle
    } - Loading`,
    component: PageLoadingComponent,
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'forgotPassword', redirectTo: 'forgot-password', pathMatch: 'full' },
  {
    path: '**',
    title: `${
      Configuration.appDeveloper + ' | ' + Configuration.appTitle
    } - Page Not Found`,
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
